import { RECOGNITION } from '../../config/recognition'

export function validateImage(file: File) {
  if (!RECOGNITION.acceptedMimeTypes.includes(file.type as typeof RECOGNITION.acceptedMimeTypes[number])) throw new Error('JPG, PNG 또는 WEBP 사진만 선택할 수 있어요.')
  if (file.size > RECOGNITION.maxImageBytes) throw new Error('사진은 8MB보다 작아야 해요.')
}

export async function resizeImage(file: File): Promise<Blob> {
  validateImage(file)
  const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' })
  const scale = Math.min(1, RECOGNITION.maxImageEdge / Math.max(bitmap.width, bitmap.height))
  const canvas = document.createElement('canvas')
  canvas.width = Math.round(bitmap.width * scale); canvas.height = Math.round(bitmap.height * scale)
  const context = canvas.getContext('2d')
  if (!context) throw new Error('사진을 처리할 수 없어요.')
  context.drawImage(bitmap, 0, 0, canvas.width, canvas.height); bitmap.close()
  return await new Promise((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('사진을 처리할 수 없어요.')), 'image/jpeg', 0.82))
}

export async function detectBarcodes(blob: Blob): Promise<string[]> {
  const Detector = (globalThis as typeof globalThis & { BarcodeDetector?: new (options: { formats: string[] }) => { detect(source: ImageBitmapSource): Promise<Array<{ rawValue: string }>> } }).BarcodeDetector
  if (Detector) {
    const bitmap = await createImageBitmap(blob)
    try { return (await new Detector({ formats: ['ean_13','ean_8','code_128','qr_code'] }).detect(bitmap)).map((item) => item.rawValue) } finally { bitmap.close() }
  }
  return []
}

export async function runOcr(blob: Blob, onProgress?: (value: number) => void): Promise<string[]> {
  const { recognize } = await import('tesseract.js')
  const result = await recognize(blob, 'kor+eng', {
    workerPath: '/ocr/worker.min.js',
    corePath: '/ocr/core',
    langPath: '/ocr/lang',
    logger: (message) => message.status === 'recognizing text' && onProgress?.(message.progress),
  })
  return result.data.text.split(/\s+/).map((item) => item.trim()).filter(Boolean).slice(0, 100)
}
